
export type StepType = typeof StepType[keyof typeof StepType];


export const StepType = {
  InviteFromSales: 'InviteFromSales',
  DataInput: 'DataInput',
  Verification: 'Verification',
  AdditionalDataInput: 'AdditionalDataInput',
  AdditionalDocuments: 'AdditionalDocuments',
  VerificationResult: 'VerificationResult',
  SignContract: 'SignContract',
  ActivateServices: 'ActivateServices',
  GetStarted: 'GetStarted',
  ShopActivation: 'ShopActivation',
  MyDokaUnavailable: 'MyDokaUnavailable',
} as const;
